$(document).ready(function() {
  function escapeAttr(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  $('.co-main-banner').each(function() {
    var $section = $(this);
    var sectionId = $section.data('section-id');
    var $frameImage = $('#co-frame-image-' + sectionId);
    var $cliponImage = $('#co-clipon-image-' + sectionId);
    var $cliponContainer = $section.find('.co-clipon-options');
    var $cliponSection = $section.find('.co-banner-clip-ons');
    var $activeFrame = $section.find('.co-frame-option.active');

    function checkAndToggleCliponSection() {
      if ($cliponContainer.find('.co-clipon-option').length === 0) {
        $cliponSection.hide();
      } else {
        $cliponSection.show();
      }
    }

    function looksLikeImageUrl(s) {
      if (!s || typeof s !== 'string') return false;
      return s.indexOf('/cdn/') !== -1 || s.indexOf('shopify') !== -1 ||
             s.indexOf('http') === 0 || (s.indexOf('/') === 0 && s.length > 1);
    }

    function buildCliponButtons(cliponOptionsData) {
      $cliponContainer.empty();
      if (cliponOptionsData && cliponOptionsData.length > 0) {
        var options = cliponOptionsData.split('||');
        options.forEach(function(opt) {
          var parts = opt.split('::');
          var label = parts[0] || '';
          var image = (parts[1] && parts[1] !== 'none') ? parts[1] : '';
          var customLabel = parts[2] || '';

          if (looksLikeImageUrl(label) && (!image || image === 'none')) {
            image = label;
            label = '';
          }

          var btnHtml = '<button type="button" class="co-clipon-option" ' +
            'data-section-id="' + escapeAttr(sectionId) + '" ' +
            'data-variant-image="' + escapeAttr(image) + '" ' +
            'data-variant-title="' + escapeAttr(label) + '" ' +
            'data-clipon-label="' + escapeAttr(customLabel) + '">' +
            '<span class="co-clipon-name">' + escapeAttr(label) + '</span>' +
            '</button>';
          $cliponContainer.append(btnHtml);
        });
      }
      checkAndToggleCliponSection();
    }

    if ($activeFrame.length) {
      buildCliponButtons($activeFrame.data('clipon-options'));
    }

    $section.find('.co-frame-option').on('click', function() {
      var $btn = $(this);

      if ($btn.hasClass('active')) {
        return;
      }

      var frameImage = $btn.data('product-image');
      var frameTitle = $btn.data('product-title');
      var cliponOptionsData = $btn.data('clipon-options');

      if ($frameImage.length) {
        $frameImage.attr('src', frameImage || '').attr('alt', frameTitle || '');
      }

      $section.find('.co-frame-option').removeClass('active');
      $btn.addClass('active');

      $cliponImage.hide().attr('src', '').attr('alt', '');
      $('#co-clipon-label-' + sectionId).hide().text('');

      buildCliponButtons(cliponOptionsData);
    });

    $section.on('click', '.co-clipon-option', function() {
      var $btn = $(this);
      var variantImage = $btn.data('variant-image');
      var variantTitle = $btn.data('variant-title');
      var cliponLabel = $btn.data('clipon-label');

      if (!variantImage || variantImage === 'none') {
        return;
      }

      if ($btn.hasClass('active')) {
        $btn.removeClass('active');
        $cliponImage.hide().attr('src', '').attr('alt', '');
        $('#co-clipon-label-' + sectionId).hide().text('');
      } else {
        $section.find('.co-clipon-option').removeClass('active');
        $btn.addClass('active');

        if (variantImage && $cliponImage.length) {
          if (variantImage.indexOf('//') === 0) {
            variantImage = 'https:' + variantImage;
          }
          $cliponImage.attr('src', variantImage).attr('alt', variantTitle).show();

          // Show label on image preview
          var $labelEl = $('#co-clipon-label-' + sectionId);
          if (cliponLabel) {
            $labelEl.text(cliponLabel).show();
          } else {
            $labelEl.hide().text('');
          }
        }
      }
    });
  });
});